
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import Title from "../../components/Title";
import schema_tiktok from "./schema_tiktok.json";
import { useNavigate } from "react-router-dom";
import { RoutePages } from "../../ultils";

schema_tiktok.servers[0].url = process.env.REACT_APP_EXECUTOR_API_URL;

const TiktokDocs = () => {
    const navigate = useNavigate();
    return (
        <div className="max-w-full bg-gradient-to-br from-blue-50 via-white to-green-50 min-h-screen">
            <Title page={RoutePages.DOCS.TIKTOK} title="Docs Tiktok" />
            {/* Brief description */}
            <div className="flex flex-col mb-4 bg-white p-4 sm:p-6 rounded-2xl shadow-lg border max-w-full mx-auto animate-fade-in">
                <div className="flex flex-col sm:flex-row justify-between items-center mb-4 gap-2">
                    <h2 className="w-full sm:w-2/3 text-2xl sm:text-3xl font-extrabold text-center sm:text-left text-blue-700 tracking-wide">
                        Tiktok API
                    </h2>
                    <div className="w-full sm:w-1/3 flex justify-center sm:justify-end gap-3">
                        <button onClick={() => navigate("/pricing/tiktok")} className="w-full sm:w-auto px-4 py-2 text-white text-base font-semibold rounded-lg bg-gradient-to-r from-green-400 to-green-600 hover:from-green-500 hover:to-green-700 shadow transition-all duration-200">
                            Free Trial
                        </button>
                        <button onClick={() => navigate("/pricing/tiktok")} className="w-full sm:w-auto px-4 py-2 text-white text-base font-semibold rounded-lg bg-gradient-to-r from-blue-400 to-blue-600 hover:from-blue-500 hover:to-blue-700 shadow transition-all duration-200">
                            Buy
                        </button>
                    </div>
                </div>
                <div className="flex flex-col mb-2">
                    <p className="text-gray-700 text-base text-begin max-w-3xl">
                        Get <b>user details</b>.<br/>
                        Get <b>video details</b>, download in <b>original quality without watermark</b>.<br/>
                    </p>
                </div>
            </div>
            <div className="bg-white rounded-2xl shadow-lg border overflow-x-auto max-w-full mx-auto animate-fade-in">
                <SwaggerUI spec={schema_tiktok} />
            </div>
        </div>
    );
};
export default TiktokDocs;
